import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import {
  PresetRecurringList,
  PresetRecurringPayload,
} from '../../modules/front-office/interface/preset-recurring-interface';
import { handleError } from '../../utils/api-error-handling';
import { encryptPayload } from '../../utils/security';

export const presetRecurringApi = createApi({
  reducerPath: 'presetRecurringApi',
  baseQuery: baseQuery,
  tagTypes: ['Preset'],
  endpoints: (builder) => ({
    getPresetRecurring: builder.query({
      query: (query) => {
        return `preset-recurring-charges${query}`;
      },
      providesTags: ['Preset'],
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
      transformResponse: async (response: PresetRecurringList) => {
        return response?.data;
      },
      forceRefetch() {
        return true;
      },
    }),
    postPresetRecurring: builder.mutation({
      query: (payload: PresetRecurringPayload) => ({
        url: 'preset-recurring-charges',
        method: 'POST',
        body: encryptPayload(payload),
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          dispatch(presetRecurringApi.util.invalidateTags(['Preset']));
        }
      },
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    deletePresetRecurring: builder.mutation({
      query: (payload) => ({
        url: `preset-recurring-charges/${payload}`,
        method: 'DELETE',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          dispatch(presetRecurringApi.util.invalidateTags(['Preset']));
        }
      },
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const {
  usePostPresetRecurringMutation,
  useLazyGetPresetRecurringQuery,
  useGetPresetRecurringQuery,
  useDeletePresetRecurringMutation,
} = presetRecurringApi;
